module.exports = __webpack_public_path__ + "static/media/main_slider_3.8d2be24d.jpg";